import React__default, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import cn from 'classnames';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styles from 'ui-components/Tooltip.scss';

var _excluded = ["children", "className", "innerClassName", "title", "text", "direction", "width", "viewportMargin"];
var DECREASE_PIXELS = 2;
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    className = _ref.className,
    innerClassName = _ref.innerClassName,
    title = _ref.title,
    text = _ref.text,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "bottom" : _ref$direction,
    width = _ref.width,
    _ref$viewportMargin = _ref.viewportMargin,
    viewportMargin = _ref$viewportMargin === void 0 ? 10 : _ref$viewportMargin,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useState = useState(false),
    visible = _useState[0],
    setVisible = _useState[1];
  var tooltip = useRef(null);
  var _useState2 = useState({
      width: typeof width !== "undefined" ? width + "px" : "auto",
      whiteSpace: typeof width !== "undefined" ? "normal" : "nowrap"
    }),
    style = _useState2[0],
    setStyle = _useState2[1];
  var onEnter = function onEnter() {
    setVisible(true);
  };
  var onLeave = function onLeave() {
    setVisible(false);
    setStyle({
      width: typeof width === "number" ? width + "px" : "auto",
      whiteSpace: typeof width !== "undefined" ? "normal" : "nowrap"
    });
  };
  useIsomorphicLayoutEffect(function () {
    calculateTooltipPosition();
  }, [visible]);
  var calculateTooltipPosition = function calculateTooltipPosition() {
    if (visible && tooltip.current && (direction === "top" || direction === "bottom")) {
      var tooltipBoundaries = tooltip.current.getBoundingClientRect();
      var bodyBoundaries = document.body ? document.body.getBoundingClientRect() : {
        width: 0,
        top: 0,
        left: 0,
        height: 0
      };
      var viewportBoundaries = {
        top: bodyBoundaries.top + viewportMargin,
        right: bodyBoundaries.width - viewportMargin,
        bottom: bodyBoundaries.height - viewportMargin,
        left: viewportMargin
      };
      var isOutsideLeft = tooltipBoundaries.left < viewportBoundaries.left;
      var isOutsideRight = tooltipBoundaries.left + tooltipBoundaries.width > viewportBoundaries.right;
      if (isOutsideLeft || isOutsideRight) {
        var viewportWidth = viewportBoundaries.right - viewportBoundaries.left;
        var newTooltipWidth = tooltipBoundaries.width;

        // Resize tooltip width if to large
        if (tooltipBoundaries.width > viewportWidth) {
          newTooltipWidth = viewportWidth - DECREASE_PIXELS;
        }
        var offset = isOutsideLeft ? tooltipBoundaries.width / 2 - (Math.abs(tooltipBoundaries.left) + viewportMargin) : viewportBoundaries.right - (tooltipBoundaries.left + tooltipBoundaries.width / 2);
        setStyle(_extends({}, style, {
          position: "absolute",
          width: newTooltipWidth + "px",
          whiteSpace: "normal",
          left: isOutsideLeft ? "-" + offset + "px" : "auto",
          right: isOutsideLeft ? "auto" : "-" + offset + "px"
        }));
      }
    }
  };
  useEffect(function () {
    if (process.browser) {
      // Hookup listeners on resize event
      window.addEventListener("resize", onLeave);

      // Remove listeners
      return function () {
        if (onLeave) {
          window.removeEventListener("resize", onLeave);
        }
      };
    }
  }, []);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, props, {
    className: cn(styles.block, [styles["block__" + direction]], className),
    tabIndex: 0,
    onFocus: onEnter,
    onBlur: onLeave,
    onMouseEnter: onEnter,
    onMouseLeave: onLeave
  }), visible && /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.tooltip, innerClassName)
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: tooltip,
    style: style,
    className: styles.tooltipInner
  }, typeof title !== "undefined" && title !== "" && /*#__PURE__*/React__default.createElement("div", {
    className: styles.title
  }, title), text))), /*#__PURE__*/React__default.createElement("div", null, children));
};

export { Tooltip };
//# sourceMappingURL=index.js.map
